import { Ability } from "ember-can";
import { service } from "@ember/service";
import { FeatureFlag } from "glesys-controlpanel/utils/feature-flags";

export default class OrganizationAbility extends Ability {
  @service session;
  @service featureFlags;

  get organization() {
    return this.model;
  }

  get isOwnerOrSuperUser() {
    return this.session.currentUser?.isSuperUser || this.organization.isOwner;
  }

  get isIndividual() {
    return this.session.currentUser.isIndividual;
  }

  get canAccessCollaborators() {
    return this.isOwnerOrSuperUser;
  }

  get canAccessInvoices() {
    return this.isOwnerOrSuperUser || this.organization.canAccessBilling;
  }

  get canAccessSettings() {
    return this.isOwnerOrSuperUser;
  }

  get canCreateProject() {
    return this.isOwnerOrSuperUser && this.isIndividual;
  }

  get canCreate() {
    return this.isIndividual;
  }

  get canAccessSupportChallenge() {
    return (
      this.featureFlags.isEnabled(this.model, FeatureFlag.SupportChallenge) ||
      this.session.currentUser.username.endsWith("@glesys.se")
    );
  }

  get canAccessRemoteHands() {
    return this.hasRemoteHandsFeatureFlag && this.isIndividual;
  }

  get canAccessBetaFeatures() {
    return (
      this.featureFlags.isEnabled(this.model, FeatureFlag.Beta) || this.session.currentUser.id.endsWith("@glesys.se")
    );
  }

  get canAccessEarlyAccessFeatures() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.EarlyAccess);
  }

  get canAccessNetworkCircuits() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.NetworkCircuits);
  }

  get canAccessColocationRackEnergyConsumption() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.ColocationRackEnergyConsumption);
  }

  get canEnableDnssec() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.Beta);
  }

  get canAccessPricing() {
    if (this.organization.isOwner) {
      return true;
    }
    return !this.featureFlags.isEnabled(this.model, FeatureFlag.ResellerPricing);
  }

  get canAccessKvmGpuOptions() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.KvmGpu);
  }

  get canAccessServerFixedPlans() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.ServerPlans);
  }

  get canAccessDbaasV2() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.DbaasV2);
  }

  get canAccessPrivateNetworkTopology() {
    return this.featureFlags.isEnabled(this.model, FeatureFlag.PrivateNetworkTopology);
  }
}
